<template>
    <VFooter id="sr-footer" class="pb-0" row>
        <div class="sr-footer-container pl-3 d-flex align-center justify-space-between">
            <div class="d-flex align-center">
                <div class="powered-by mr-2 gray-border--text">POWERED BY</div>
                <SrBrandLogo />
            </div>

            <div class="d-flex flex-wrap justify-center ml-5 mr-5 footer-items">
                <SrButton
                    v-for="(item, index) in items"
                    :key="index"
                    :href="item.href"
                    :target="linkTarget(item.target)"
                    text
                    color="gray-border"
                >
                    {{ item.title }}
                </SrButton>
            </div>

            <div class="legal-text gray-border--text text-sm-right ml-auto">&copy; Sportradar, All Rights Reserved</div>
        </div>
    </VFooter>
</template>

<script>
import { SrBrandLogo } from '../../components/SrBrandLogo';
import { SrButton } from '../../components/SrButton';

export default {
    name: 'SrFooter',
    components: {
        SrButton,
        SrBrandLogo,
    },
    props: {
        items: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    methods: {
        linkTarget(target) {
            if (!target) {
                return '_parent';
            }
            return target;
        },
    },
};
</script>
